module.exports = __webpack_public_path__ + "static/BookMyShow-9b0fee46d669bf03a79c336a153eb797.png";